import { Component,Inject, OnInit, Input,ViewChild, ChangeDetectorRef, Output, EventEmitter } from '@angular/core';
import { WorkPackageResource } from 'core-app/modules/hal/resources/work-package-resource';
import { HttpClient } from '@angular/common/http';
import { data } from 'jquery';
import { GroupDescriptor } from '../wp-single-view/wp-single-view.component';
import { SignaturePad } from 'angular2-signaturepad/signature-pad';
import { SignaturePasswordModalComponent } from '../../../components/shared/signature-password-modal/signature-password-modal.component';



@Component({
  selector: 'wp-single-assignNext',
  templateUrl: './wp-single-assignNext.component.html',
  styleUrls: ['./wp-single-assignNext.component.sass']
})
export class WpSingleAssignNextComponent implements OnInit {
  @ViewChild(SignaturePad,{static:true}) signaturePad:SignaturePad; //第二视图
  @Input() public workPackage: WorkPackageResource;
  @Input() public groupedFields: GroupDescriptor;
  @Input() public dateTime:any = ''
  @Output() public clone = new EventEmitter();

  // 修改密码弹框相关属性
  public showPasswordModal: boolean = false;
  private tempSignatureData: any = null;
  
  @ViewChild(SignaturePasswordModalComponent, { static: false }) passwordModal: SignaturePasswordModalComponent;
  
  constructor(
    @Inject('DAYJS') private dayjs:any,
    readonly http: HttpClient,
    private changeDetectorRef: ChangeDetectorRef
  ) { }
  public  signaturePadOptions: Object = {
    minWidth: 0.5,// 比划的粗细,
    canvasWidth: 545, // 可写宽度
    canvasHeight: 200,// 可写高度
  };
  private newHeaders: any = {}
  public watchers: any
  public watcherslist: any
  public selectWatchers: any = null
  public statusdata: any
  public customFieldGroupPrincipal: any = []
  public okbutton: boolean = true
  public canSubmit:boolean = false
  public isDefoultSign:boolean = false

  //INSPECTION DETAIL的三个框
  //approval  name 
  public approvalArr: any = [];
  //diaspproval name
  public diaspprovalTex:any = [];
  public signatureType=''
  requestHeader: any = {
    'X-Authentication-Scheme': 'Session',
    'X-Requested-With': 'XMLHttpRequest'
  };
  //判断跳转
  public approval: any = [
    'Accept',
  ]
  public disapproval = [ 'Not Ready', 'Reject']
  //状态
  public approvalTip = 'Closed with approval'
  public disapprovalTip = 'Closed with disapproval'
  public signatureImage = '';
  public signatureId = ''
  public custom_sign_field_name = ''
  public currentUser:any = document.querySelector('meta[name=current_user]')
  public isLoading = false
  public isShowDefoultSign:string = ''
  public isTime:boolean = true
  public handleSelect:any = null
  ngOnInit() {
    //console.log('this.groupedFields',this.groupedFields);
    //console.log('this.workPackage',this.workPackage);
    if(this.currentUser.dataset.sign_doc_id){
      this.isShowDefoultSign =`${window.location.origin}/api/v3/logical_docs/doc/${
        this.currentUser.dataset.sign_doc_id
      }/stream`
    }
    console.log(this.isShowDefoultSign,'this.isShowDefoultSign');
    if(this.dayjs(this.dateTime).isBefore(this.dayjs())&&this.workPackage.status.name == 'New'){
      this.isTime = false 
    }
    this.signaturePad.onEnd = () => {
      console.log(this.dateTime,'this.dateTime',this.workPackage);
      if(!this.isTime){
        this.canSubmit = false 
      }else{
        this.canSubmit = true
      }
    }
    const csrf_token: string | undefined = jQuery("meta[name=csrf-token]").attr("content");
    this.newHeaders["X-Authentication-Scheme"] = "Session";
    this.newHeaders["X-Requested-With"] = "XMLHttpRequest";

    if (csrf_token) {
      this.newHeaders["X-CSRF-TOKEN"] = csrf_token;
    }
    // this.getStatus()
    this.getSignatureType()
    this.watchershttp()
    this.getWatchersList()

    // //approvalArr 三个点击选项的名字
    // let groupedData: any = this.groupedFields
    // //console.log(groupedData)
    // groupedData.forEach((data: any) => {
    //   if (data.name == 'Inspection detail') {
    //     let groupMembers = data.members;
    //     groupMembers.forEach((datas: any) => {
    //       if (this.approval.indexOf(datas.label) != -1) {
    //         this.approvalArr.push(datas.name)
    //       }
    //       if (this.disapproval.indexOf(datas.label) != -1) {
    //         this.diaspprovalTex.push(datas.name)  //cusfim 44
    //       }
    //     })
    //   }
    // })
  }
  getSignatureType(){
    this.httpGet(`/api/v3/work_packages/risc_status`).subscribe((datas: any) => {
      const excluded = ['Closed', 'Cancelled', 'Rejected']
      const statuslist = datas.filter((item:any)=>{
        return excluded.indexOf(item.name) == -1
      })    
       let statusIndex = statuslist.findIndex((item:any)=>{
        return item.id == this.workPackage.status.id
      })
      if(statusIndex == 4){
        const data:any = this.groupedFields
          let flag = false
        data.forEach((element:any) => {
                element.members.forEach( (item:any) => {
                  // 这是跳过一个状态签名
                  if(item.field.value ===  false && item.label == 'Countersigned by RE or above rank ?'){
                      flag = true
                  }
                })
            });
            if(flag){
                this.statusdata = statuslist[statusIndex+2]
            }else{
                this.statusdata = statuslist[statusIndex+1]
            }
            // 最后一步 判断是approval 还是 disapproval
      }else if (statusIndex == 6){
            //approvalArr 三个点击选项的名字
        let groupedData: any = this.groupedFields
        //console.log(groupedData)
        groupedData.forEach((data: any) => {
          if (data.name == 'Inspection detail') {
            let groupMembers = data.members;
            const approvalType = groupMembers.some((item:any)=>{
              return this.approval.indexOf(item.label) != -1 && item.field.value === true
            })
            if(approvalType){
              this.statusdata = statuslist[statusIndex+1]
            }else{
              this.statusdata = statuslist[statusIndex+2]
            }
          }
        })
      } else{
        this.statusdata = statuslist[statusIndex+1]
      }
        let indexdata = this.workPackage._attributeGroups.filter((data: any) => {
          let dataindex = data.statuses.findIndex((res: any) => { return res.id == this.statusdata.id })
          return dataindex >= 0
        })

        this.getCFavailableList(indexdata, this.statusdata)

        let index = this.workPackage._attributeGroups.filter((data: any) => {
          let dataindex = data.statuses.findIndex((res: any) => { return res.id == this.workPackage.status.id })
          return dataindex >= 0
        })

        index.forEach((element: any) => {
          element.attributes.forEach((data: any) => {
            //console.log(this.workPackage.schema[data],'this.workPackage.schema[data]');
            
            if (this.workPackage.schema[data].name.indexOf('Signature') >= 0) {
              //console.log(data, this.workPackage.customDefaultSignValues[data])
              if(!this.workPackage.customDefaultSignValues[data]){
                //console.log('有没有执行');
                this.signatureType = data
                this.custom_sign_field_name = this.workPackage.schema[data].name
              }else{
                this.signatureId = this.workPackage.customDefaultSignValues[data]
                this.signatureImage = `${window.location.origin}/api/v3/logical_docs/doc/${
                  this.workPackage.customDefaultSignValues[data]
                }/stream`
                this.canSubmit = true
              }
              if (this.workPackage[data] || this.workPackage.customDefaultSignValues[data]) {
              } else {
                this.okbutton = false
                // this.okbutton = true
              }
            }

          });
        });
      // this.signatureType = datas.signatureType
    })
  }
  getStatus() {
    //所有选项卡中最后一个选项卡的状态
    let endStatus  = this.workPackage._attributeGroups[this.workPackage._attributeGroups.length-1].statuses;
    //console.log(endStatus)
    this.httpGet(`/api/v3/work_packages/${this.workPackage.id}`).subscribe((datas: any) => {
      //console.log('datas--------', datas)
      this.workPackage.customDefaultSignValues = datas.customDefaultSignValues
      this.httpPost(`/api/v3/work_packages/${this.workPackage.id}/form`, { lockVersion: datas.lockVersion, _links: {} }).subscribe((data: any) => {
        //console.log('data====--------', data, this.approvalArr)
        let allowedValues = data._embedded.schema.status._embedded.allowedValues
        let zhoghixunhuan = true
        let statusindex = allowedValues.findIndex((datares: any) => { return datares.id == this.workPackage.status.id })
      //当前状态名workpackgage最后一个分类的状态
      //console.log(endStatus.length != 0 &&this.workPackage.status.name == endStatus[0].name)
        if(endStatus.length != 0 &&this.workPackage.status.name == endStatus[0].name){
          //console.log('endStatus',endStatus);
          
        //判读当前的状态是否为workpackage里面的最后一个状态，是的话进入下一层判断
        this.approvalArr.forEach((appdata: any) => {  //approvalArr 跳转approval
          //NSPECTION DETAIL 中The following deficiencies have been noted: 被勾选，assigNext跳转disapprovalTip，否则跳转approvalTip
          if(!zhoghixunhuan) return   //跳出foreach循环
          if (datas[appdata]) {   // 
          
            allowedValues.forEach((item: any) => {
              if (this.approvalTip.indexOf(item.name) != -1) { //approvalTip  跳转disApproval
                zhoghixunhuan = false
                this.statusdata = item
              }
            });
            return;
          } else if (this.diaspprovalTex.some( (dis:any) => {
            return datas[dis]
          })) { //disapproval
            allowedValues.forEach((item: any) => {
              if (this.disapprovalTip.indexOf(item.name) != -1) {
                zhoghixunhuan = false
                this.statusdata = item
              }
            });
            return;
          } else {  //跳转下一条操作
            let statusindex = allowedValues.findIndex((datares: any) => { return datares.name == 'Closed' })
            this.statusdata = allowedValues[statusindex]
            // if (statusindex + 1 >= allowedValues.length) {
            //   this.statusdata = allowedValues[statusindex]
            // } else {
            //   this.statusdata = allowedValues[statusindex + 1]
            // }
          }
        });
        }else{ //当前分类不是最后一个
          //console.log('当前分类不是最后一个！');
        
          let statusindex = allowedValues.findIndex((datares: any) => { return datares.id == this.workPackage.status.id })
          if (statusindex + 1 >= allowedValues.length) {
            this.statusdata = allowedValues[statusindex]
          } else {
            let groupedData: any = this.groupedFields
            let statuses = groupedData.find( (el:any):boolean => {
              if(el.name === "FOR Supervisor: Countersigned by RE/SIOW/SSOE") {
                return true
              } else{
                return false
              }
            })
            groupedData.forEach((element:any) => {
                element.members.forEach( (item:any) => {
                  if(item.field.value ===  false && item.label == 'Countersigned by RE or above rank ?'){
                    for(let status of statuses.status){
                      //console.log(status.name, allowedValues[statusindex + 1].name)
                     if(status.name === allowedValues[statusindex + 1].name) {
                       statusindex++
                     }
                    }
                  }
                })
            });
            this.statusdata = allowedValues[statusindex + 1]
          }
        }

        this.watchershttp()
        this.getWatchersList()

        let indexdata = this.workPackage._attributeGroups.filter((data: any) => {
          let dataindex = data.statuses.findIndex((res: any) => { return res.id == this.statusdata.id })
          return dataindex >= 0
        })

        this.getCFavailableList(indexdata, this.statusdata)

        let index = this.workPackage._attributeGroups.filter((data: any) => {
          let dataindex = data.statuses.findIndex((res: any) => { return res.id == this.workPackage.status.id })
          return dataindex >= 0
        })

        index.forEach((element: any) => {
          element.attributes.forEach((data: any) => {
            //console.log(this.workPackage.schema[data],'this.workPackage.schema[data]');
            
            if (this.workPackage.schema[data].name.indexOf('Signature') >= 0) {
              //console.log(data, this.workPackage.customDefaultSignValues[data])
              if(!this.workPackage.customDefaultSignValues[data]){
                //console.log('有没有执行');
                this.signatureType = data
                this.custom_sign_field_name = this.workPackage.schema[data].name
              }else{
                this.signatureId = this.workPackage.customDefaultSignValues[data]
                this.signatureImage = `${window.location.origin}/api/v3/logical_docs/doc/${
                  this.workPackage.customDefaultSignValues[data]
                }/stream`
                this.canSubmit = true
              }
              if (this.workPackage[data] || this.workPackage.customDefaultSignValues[data]) {
              } else {
                this.okbutton = false
                // this.okbutton = true
              }
            }

          });
        });
      })
    })
  }

  setgroup_principal() {
    return new Promise((resolve, reject) => {
      if(this.customFieldGroupPrincipal.length == 0 && this.statusdata.name.indexOf('Closed') != -1){
        resolve(true)
      }else if (this.customFieldGroupPrincipal.length ==0){
        reject(false)
      }else{
            this.customFieldGroupPrincipal.forEach((element: any) => {
            const selectData = element.principals.find((item:any)=>{
              return Number(item.id) == Number(this.handleSelect)
            })
            this.newHeaders['Content-Type'] = 'application/json'
            let file = { custom_field_group_name: element.custom_field.name, principal_id: selectData.id, principal_type: selectData.type }
            this.http.patch(`/api/v3/work_packages/${this.workPackage.id}/change_custom_field_group_principal`, file, { withCredentials: true, headers: this.newHeaders }).subscribe((res: any) => {
              resolve(res)
            },(error)=>{
              reject(error)
            })
        });
      }
  })
  
  }
    public maxRetries = 3;
    public retryCount = 0;
  updataRiscStatus(password:string, requedata: any = null){
      if(this.retryCount >this.maxRetries) {
        this.isLoading = false;
        this.passwordModal.setError('更改状态失败，请联系管理员');
        return
      }
      if (this.statusdata.id != this.workPackage.status.id) {
        this.httpGet(`/api/v3/work_packages/${this.workPackage.id}`).subscribe((data: any) => {
          console.log(this.statusdata,'statusdata',requedata);
          let httpdata: any = {is_sign: true, sign_pwd: password, lockVersion: data.lockVersion, _links: { status: { href:'/api/v3/statuses/'+this.statusdata.id } } }
          if(requedata){
            httpdata = { ...requedata, ...httpdata}
          }
          console.log('httpdata',httpdata);
          this.http.patch(`/api/v3/work_packages/${this.workPackage.id}`, httpdata, {
            withCredentials: true,
            headers: this.newHeaders
          }).subscribe((status: any) => {
            this.isLoading = false;
            location.reload(true)
          },(error)=>{
            this.isLoading = false;
            this.passwordModal.setError(error.error.message);
            console.error('提交签名时出错:', error);
          })
        },
        (error) =>{
          this.retryCount++
          this.updataRiscStatus(password,requedata)
        }
      )
      }
  }

  async updateStatus(password: string, requedata: any = null) {
    this.httpPost(`/api/v3/work_packages/${this.workPackage.id}/watchers`, { "user": { "href": this.selectWatchers } }).subscribe((res: any) => {
      // this.watchers = res._embedded.elements
      // this.getWatchersList()
      // this.watchershttp()
      this.updataRiscStatus(password, requedata)
    },
    () => {
       this.updataRiscStatus(password, requedata)
       }
    );
  }
  dataURLtoBlob(dataurl:any) {
    var arr = dataurl.split(','), mime = arr[0].match(/:(.*?);/)[1],
        bstr = atob(arr[1]), n = bstr.length, u8arr = new Uint8Array(n);
    while (n--) {
        u8arr[n] = bstr.charCodeAt(n);
    }
    return new Blob([u8arr], { type: mime });
  }
  requefunckpost(data: any,url:any){
    return this.http.post(
      url,
      data,
      {
        withCredentials: true,
        headers: this.requestHeader
      }
    );
  }
  requefunckpatch(data: any,url:any){
    return this.http.patch(
      url,
      data,
      {
        withCredentials: true,
        headers: this.requestHeader
      }
    );
  }
  checkDefaultSignChange() {
    if(!this.isTime){
      return
    }
    if(this.isDefoultSign) {
      this.signatureImage = this.isShowDefoultSign
      this.signatureId = this.currentUser.dataset.sign_doc_id
      this.canSubmit = true
      // this.http.post(
      //   `/api/v3/work_packages/${this.workPackage.id}/custom_fields/set_defauls_sign`,
      //   {
      //     custom_sign_field_name: this.custom_sign_field_name,
      //     custom_sign_field_default_value: this.currentUser.dataset.sign_doc_id
      //   },
      //   {
      //     withCredentials: true,
      //     headers: this.requestHeader
      //   }
      // ).subscribe( (res) => {
      //   this.signatureId = this.currentUser.dataset.sign_doc_id
      //   this.signatureImage = `${window.location.origin}/api/v3/logical_docs/doc/${
      //     this.currentUser.dataset.sign_doc_id
      //   }/stream`
      //   this.canSubmit = true
      //   // this.getStatus()
      //   // this.watchershttp()
      //   // this.getWatchersList()
      // })  
    } else {
      this.signatureId = ''
      this.signatureImage = ''
      this.canSubmit = false
      // this.signatureImage = false
      // this.http.post(
      //   `/api/v3/work_packages/${this.workPackage.id}/custom_fields/set_defauls_sign`,
      //   {
      //     custom_sign_field_name: this.custom_sign_field_name,
      //     custom_sign_field_default_value: ''
      //   },
      //   {
      //     withCredentials: true,
      //     headers: this.requestHeader
      //   }
      // ).subscribe( (res) => {
      //   this.signatureId = ''
      //   this.signatureImage = ''
      //   this.canSubmit = false
      // })
    }
  }
  showPasswordModalClick() {
    if(!this.canSubmit )
        return
  
    this.showPasswordModal = true;
    console.log('this.showPasswordModal',this.showPasswordModal);
    
  }

  // 修改密码确认相关方法
  handleClose() {
    this.showPasswordModal = false;
  }

  async handleConfirm(password: string) {
    this.isLoading = true;
    try {
      if (password) {
        this.drawComplete(password);
      } else {
        if (this.passwordModal) {
          this.passwordModal.setError('密码错误，请重试');
        }
      }
    } finally {
    }
  }


  drawComplete(password: string) {
    if(!this.canSubmit )
      return
    // if(this.isDefoultSign && this.currentUser.dataset.sign_doc_id){
    //    this.http.post(
    //     `/api/v3/work_packages/${this.workPackage.id}/custom_fields/set_defauls_sign`,
    //     {
    //       custom_sign_field_name: this.custom_sign_field_name,
    //       custom_sign_field_default_value: this.currentUser.dataset.sign_doc_id
    //     },
    //     {
    //       withCredentials: true,
    //       headers: this.requestHeader
    //     }
    //   ).subscribe( (res) => {
    //     // this.canSubmit = false
    //      this.updateStatus(password)
    //   })  
    //   return
    // }
    this.signatureImage = this.signaturePad.toDataURL();
    
  
    let blob = this.dataURLtoBlob(this.signatureImage)
    var files = new File([blob], 'drawComplete.png', { type: blob.type })
    let file = new FormData();
    file.append('file', files);
    file.append('prefix', 'risc');
    // this.dipslesignature = false
    let projectId:any = document.querySelector('meta[name=current_project]')

    this.http.get(`/api/v3/work_packages/${this.workPackage.id}`).subscribe((worlpageres:any)=>{
      if(this.isDefoultSign && this.currentUser.dataset.sign_doc_id){
        let requedata:any = {sign_pwd: password,is_sign: true,lockVersion: worlpageres.lockVersion,_links: {}}
        if(!this.signatureType){
           window.alert('签名类型错误,请刷新页面')
            return
          }
          requedata[this.signatureType] = this.currentUser.dataset.sign_doc_id

          // this.requefunckpatch(requedata,`/api/v3/work_packages/${this.workPackage.id}`).subscribe((res:any)=>{
            
              // this.getStatus()
              // console.log(requedata,'requedata',res)
              
              this.setgroup_principal().then((res)=>{
                 this.updateStatus(password,requedata)
              }).catch(()=>{
                 this.isLoading = false;
                 this.passwordModal.setError('指定人錯誤');
              })
          // },(error)=>{
          //   this.isLoading = false;
          //   this.passwordModal.setError(error.error.message);
          //   console.error('提交签名时出错:', error);
          // })
        
      }else{
      this.requefunckpost(file,`/api/v3/projects/${projectId.dataset.projectId}/sign`).subscribe((imgdata:any)=>{
        let requedata:any = {sign_pwd: password,is_sign: true,lockVersion: worlpageres.lockVersion,_links: {}}
        if(!this.signatureType){
          window.alert('签名类型错误,请刷新页面')
           return
         }
          requedata[this.signatureType] = imgdata.doc_id

          // this.requefunckpatch(requedata,`/api/v3/work_packages/${this.workPackage.id}`).subscribe((res:any)=>{
            // console.log('提交签名时出错res',res);
            
              // this.getStatus()
              this.setgroup_principal().then((res)=>{
                this.updateStatus(password,requedata)
              }).catch(()=>{
                this.passwordModal.setError('指定人錯誤');
              }).finally(()=>{
              })
          // },(error)=>{
          //   this.isLoading = false;
          //   this.passwordModal.setError(error.error.message);
          //   console.error('提交签名时出错:', error);
          // })
        })
      }
      // })
    })
}

  //获取可添加watchers
  watchershttp() {
    this.httpGet(`/api/v3/work_packages/${this.workPackage.id}/available_watchers?pageSize=9999`).subscribe((res: any) => {
      this.selectWatchers = null
      this.watchers = res._embedded.elements.map((item:any)=>{
        return {
          ...item,
          userName: item.position ? `${item.name} [${item.position}]` : item.name
        }
      })
      this.changeDetectorRef.markForCheck();
      this.changeDetectorRef.detectChanges();
    });
  }


  changeswatchers(item: any) {
  }

  //添加watchers
  addwatchers() {
    this.httpPost(`/api/v3/work_packages/${this.workPackage.id}/watchers`, { "user": { "href": this.selectWatchers } }).subscribe((res: any) => {
      // this.watchers = res._embedded.elements
      this.getWatchersList()
      this.watchershttp()

    });
  }

  //获取添加了watchers列表
  getWatchersList() {
    this.httpGet(`/api/v3/work_packages/${this.workPackage.id}/watchers`,).subscribe((res: any) => {
      this.watcherslist = res._embedded.elements
      // //console.log("getFileRefNoInfo", res._embedded.elements);
      this.changeDetectorRef.markForCheck();
      this.changeDetectorRef.detectChanges();
    });
  }

  //删除watchers
  deletewatchers(item: any) {
    this.httpDelete(`/api/v3/work_packages/${this.workPackage.id}/watchers/${item.id}`).subscribe((res: any) => {
      this.getWatchersList()
      this.watchershttp()
    })
  }

 async getCFavailableList(customFieled: any, statuses: any) {
    let groupedFieldsdata: any = this.groupedFields
    console.log(groupedFieldsdata,customFieled,'groupedFieldsdata');
    
    for(let element of customFieled) {
      let quanxdata = groupedFieldsdata.find((res: any) => {
        return res.name == element.name
      })
      let res:any = await  this.httpGet(`/api/v3/work_packages/${this.workPackage.id}/custom_field_group_available_principal?custom_field_group_name=${element.name}`).toPromise() 
      const principals = res.principals
        let name = ''
        res.principals.forEach((element:any, i:any) => {
          if(i == 0){
            if(element.lastname || element.firstname) {

              name = element.lastname + element.firstname
            } else {
              name += element.name 
            }
          } else {
            if(element.lastname || element.firstname) {

              name = name + ','+ element.lastname + element.firstname
            } else {
              name += ',' + element.name 
            }
          }
        });
        for(let i = principals.length -1 ; i>=0 ; i--) {
          if(principals[i].hasOwnProperty('users')) {
            let users: Array<any> =  principals[i].users
            //console.log(users)
            principals.splice(i + 1,0, ...users)
          }
        }
        let panduan = true
        let elementpadnuan = true
        principals.forEach((prinres: any) => {
          if (panduan && elementpadnuan) {
            if (quanxdata.principal_name == `${prinres.lastname} ${prinres.firstname}`) {
              this.customFieldGroupPrincipal.push({ principals: principals, select: prinres.id, custom_field: element })
              panduan = false
            } else {
              if (elementpadnuan) {
                //assignNext里面的选项
                // principals.unshift({ id: null, login: quanxdata.principal_name })
                this.customFieldGroupPrincipal.push({ principals: principals, select: null, custom_field: element })
                elementpadnuan = false
              }

            }
          }
        });
        console.log(panduan,'panduan');
        
        // if(panduan){
        //   principals.unshift({
        //     id:null,
        //     login: name
        //   })
        // }
        if(res.real_principal&&res.real_principal.id){
          this.handleSelect = res.real_principal.id
        }else{
          const userPrincipal = this.customFieldGroupPrincipal[0].principals.find((p:any) => p.type === 'User');
          this.handleSelect = userPrincipal ? userPrincipal.id : '';
          // this.setgroup_principal('','');
        }

        this.changeDetectorRef.markForCheck();
        this.changeDetectorRef.detectChanges();
    }

  }

  customFielditemlists(itemlists: any) {
    let datatext
    if (itemlists.id) {
      let position = itemlists.position ? '[' + itemlists.position + ']' : ''
      if(itemlists.lastname || itemlists.firstname) {

        datatext = `${itemlists.lastname}${itemlists.firstname} ${position}`
      } else {
        datatext = `${itemlists.name} ${position}`
      }
    } else {
      datatext = itemlists.login
    }

    return datatext

  }

  httpGet(url: string) {
    this.newHeaders['Content-Type'] = 'application/json'
    return this.http.get(url, { withCredentials: true, headers: this.newHeaders })
  }

  httpPost(url: string, data: any, isPassword: boolean = false) {
    this.newHeaders['Content-Type'] = 'application/json'
    return this.http.post(url, data, { withCredentials: true, headers: this.newHeaders })
  }

  httpDelete(url: string) {
    let Headers = this.newHeaders
    Headers['Content-Type'] = 'application/hal+json'
    return this.http.delete(url, { withCredentials: true, headers: Headers })
  }

  clonebutton() {
    this.clone.emit()
  }

}
